import React from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../../../../generic/ui/DatePicker';
import PrintIcon from '../../../../../generic/icons/IconLib/PrintIcon';
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton';
import { SearchInput } from '../../../../../generic/ui/SearchInput';

interface Props {
    input: string;
    setInput: (value: string) => void;
    setDate: (value: string) => void;
    handleDate: (e: object) => void;
    selectedDate: Date | false;
    isOffice: boolean;
    onPrintLog: () => void;
    placeholder?: string;
}

const DriversSelectBar: React.FC<Props> = ({
    input,
    setInput,
    setDate,
    handleDate,
    selectedDate,
    isOffice,
    onPrintLog,
    placeholder = 'חיפוש קו, נהג או לקוח',
}) => (
    <SelectBarShell>
        <SearchInput
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={placeholder}
        />
        <DatePicker
            selected={selectedDate}
            setDate={setDate}
            onChange={(date) => {
                if (date) handleDate(date);
            }}
        />
        {isOffice && (
            <KbdChipButton onClick={onPrintLog} aria-label='הדפסת יומן' title='הדפסת יומן'>
                <PrintIcon />
            </KbdChipButton>
        )}
    </SelectBarShell>
);

export default DriversSelectBar;

const SelectBarShell = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
`;
